import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  Card,
  CARD_SIZE,
  Button,
  Divider,
  Chips,
  CHIPS_COLOR,
  Icon,
  Link,
} from 'veloe-ds';
import {
  salvarDesconto,
  resetTipoPagamento,
} from '../../actions/pedidoActions';
import { modalTarifas, modalInformativo } from '../../Components/Modais';
import ScriptTag from 'react-script-tag';

import './reviseCompra.scss';
import {
  eventTrackBasic,
  eventTrackEcommerce,
  eventTrackRoute,
} from '../../utils/pushDataLayer.js';
import { APP_PAGES } from '../../routes';
import { salvarDescontoAsync } from '../../actions/asyncActions';
import plus from '../../assets/icons/plus.svg';
import minus from '../../assets/icons/minus.svg';

import { veloeGraphQlApi } from '../../api/graphql/graphQLAPI';
import resumo from '../../mutations/resumo';
import { withSnackbar } from 'notistack';
import { PERCENTAGE_MINIUM_RECHARGE } from '../../utils/recharge';

import { modalPlanoSemMensalidade } from '../../Components/Modais';
import {
  rateCalculation,
  finalBalanceCalculation,
} from '../../Components/RechargeRate';

/**
 * Exibe as informações de produto adquirido, pagamento, de cadastro do cliente e permite criar a senha
 *
 * */

const ReviseCompra = ({ pedido, history, activeLoader, inactiveLoader }) => {
  const {
    listaDeProdutos,
    tipoPagamento,
    dadosUsuario,
    dadosEndereco,
    ondeUsar,
    totalProdutos,
    valorRecarga,
  } = pedido;

  const [botaoVerMais, setBotaoVerMais] = useState({
    status: false,
    label: 'Ver Mais',
    icon: plus,
  });

  const dispatch = useDispatch();
  const [openModalInformativo, setOpenModalInformativo] = useState(false);
  const [pedidoAtual] = useState(pedido);
  const [textoTermos, setTextoTermos] = useState('');
  const [subProductId] = useState(
    JSON.parse(localStorage.getItem('proposta')).subProdutoId,
  );

  useEffect(() => {
    const proposta = JSON.parse(localStorage.getItem('proposta'));
    if (proposta.subProdutoId !== '002') {
      dispatch(resetTipoPagamento());
    }
    if (!proposta) {
      history.push(APP_PAGES.CADASTRO);
    }

    eventTrackEcommerce(pedidoAtual, proposta, ['checkout', 1]);
    eventTrackRoute('revise-compra');
  }, [
    dispatch,
    history,
    ondeUsar.id,
    pedidoAtual,
    subProductId,
    tipoPagamento,
  ]);

  const btnVerMais = () => {
    if (botaoVerMais.status === true) {
      setBotaoVerMais((prevState) => {
        return { ...prevState, status: false, label: 'Ver Mais', icon: plus };
      });
    } else {
      setBotaoVerMais((prevState) => {
        return { ...prevState, status: true, label: 'Ver Menos', icon: minus };
      });
    }
  };

  const chamaFuncRand = async () => {
    const proposta = JSON.parse(localStorage.getItem('proposta'));
    const reCaptcha = await window.grecaptcha.execute(
      process.env.REACT_APP_KEY_RECAPTCHA,
      {
        action: 'homepage',
      },
    );

    eventTrackBasic('clique:botao', 'continuar-resumo');

    activeLoader();
    veloeGraphQlApi(resumo, {
      idProposta: proposta.dados.id,
      captchaResponse: reCaptcha,
    })
      .then((data) => {
        const { dados, validatorResponse } = data['resumoFCG'];
        if (dados) {
          inactiveLoader();
          history.push(APP_PAGES.FORMA_PAGAMENTO);
        } else {
          const { errors } = validatorResponse;
          inactiveLoader();
          return errors.map((error) => {
            setTextoTermos(error.message);
            setOpenModalInformativo(true);
          });
        }
      })
      .catch((err) => {
        inactiveLoader();
        setTextoTermos(err.message);
        setOpenModalInformativo(true);
      });
  };

  return (
    <div className="containerComponent">
      <div className="containerText">
        <div className="containerLabel">
          <label className="areaTexto">Confirme se está tudo certo</label>
        </div>
      </div>
      <div className="containerArea">
        <div className="containerReviseCompra">
          <Card {...{ size: CARD_SIZE.LARGE }}>
            <div className="containerCardReviseCompra">
              <div className="containerTextReviseCompra">
                <h1 className="tituloCardReviseCompra titulo-resumo">
                  Resumo do pedido
                </h1>

                <Divider type="full" onBg="light" />

                {listaDeProdutos.map((produto) => {
                  return (
                    <React.Fragment key={produto.id}>
                      <label className="tituloDestaqueReviseCompra titulo-produto">
                        {produto.titulo}
                      </label>

                      <div className="valoresReviseSuaCompra">
                        <label className="tituloReviseCompra">Quantidade</label>
                        <label className="valorRevisaoPedido quantidade">
                          {produto.quantidade}
                        </label>
                      </div>

                      {subProductId !== '001' && (
                        <div className="valoresReviseSuaCompra">
                          <label className="tituloReviseCompra">Valor</label>

                          <div className="containerValoresProdutos">
                            <label className="valorRevisaoPedido valor">
                              R$ {produto.valor < 10 && '0'}
                              {produto.valor.toFixed(2).replace('.', ',')}
                            </label>
                          </div>
                        </div>
                      )}

                      <div className="valoresReviseSuaCompra">
                        <label className="tituloReviseCompra">Onde usar</label>
                        <label className="valorRevisaoPedido onde-usar">
                          <b>
                            {subProductId !== '001'
                              ? ondeUsar.valorTexto
                              : 'Pedágios/Estacionamentos'}
                          </b>
                        </label>
                      </div>

                      <Divider type="full" onBg="light" />
                    </React.Fragment>
                  );
                })}

                <label className="tituloDestaqueReviseCompra">
                  {subProductId !== '001' ? 'Mensalidade' : 'Recarga'}
                </label>

                <div className="valoresReviseSuaCompra">
                  <label className="tituloReviseCompra">
                    Tipo de pagamento
                  </label>
                  <label className="valorRevisaoPedido tipo-pagamento">
                    {tipoPagamento === 'pos-pago'
                      ? 'Pós pago'
                      : subProductId !== '001'
                      ? 'Recarga automática'
                      : 'Recarga manual'}
                  </label>
                </div>

                <div className="valoresReviseSuaCompra">
                  <label className="tituloReviseCompra">Recarga</label>
                  <label className="valorRevisaoPedido tipo-pagamento">
                    R$ {valorRecarga},00
                  </label>
                </div>
                {tipoPagamento === 'recarga-automatica' && (
                  <div className="valoresReviseSuaCompra">
                    <label className="infoRecarga">
                      Sempre que seu saldo estiver inferior a R$
                      {(PERCENTAGE_MINIUM_RECHARGE / 100) * valorRecarga}, uma
                      nova recarga é realizada.
                    </label>
                  </div>
                )}

                {subProductId !== '001' && (
                  <div className="valoresReviseSuaCompra">
                    <label className="tituloReviseCompra">Valor</label>
                    <div className="containerValoresMensalidade">
                      <Chips
                        {...{
                          color: CHIPS_COLOR.SUCCESS,
                          label: ondeUsar.textoDesconto,
                          id: 'chips-desconto',
                        }}
                      />
                      <label className="textoPequeno tem-mensalidade">
                        {ondeUsar.valor}
                      </label>
                      <div className="textoPequeno">
                        {modalTarifas(
                          ondeUsar.mesesBonificacao,
                          ondeUsar.valorTarifa,
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {subProductId === '001' && (
                  <>
                    <Divider type="full" onBg="light" />
                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">Tarifa</label>
                      <label className="valorRevisaoPedido tipo-pagamento">
                        - R$ {rateCalculation(valorRecarga)}
                      </label>
                    </div>

                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">
                        Será descontado do valor de sua recarga.
                      </label>
                    </div>

                    <div className="valoresReviseSuaCompra">
                      {modalPlanoSemMensalidade(true)}
                    </div>
                  </>
                )}

                <Divider type="full" onBg="light" />
                {botaoVerMais.status && (
                  <>
                    <label className="tituloDestaqueReviseCompra dados-pessoais">
                      Dados pessoais
                    </label>
                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">E-mail</label>
                      <label className="valorRevisaoPedido e-mail">
                        {dadosUsuario.email}
                      </label>
                    </div>

                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">Nome</label>
                      <label className="valorRevisaoPedido nome-usuario">
                        {dadosUsuario.nomeCompleto}
                      </label>
                    </div>

                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">CPF</label>
                      <label className="valorRevisaoPedido cpf-usuario">
                        {dadosUsuario.cpf}
                      </label>
                    </div>

                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">Celular</label>
                      <label className="valorRevisaoPedido celular-usuario">
                        {dadosUsuario.celular}
                      </label>
                    </div>

                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">Endereço</label>
                      <div className="containerValoresMensalidade">
                        <label className="valorRevisaoPedido endereco-usuario">
                          {dadosEndereco.endereco}, {dadosEndereco.numero},{' '}
                          {dadosEndereco.bairro}
                        </label>
                        <label className="valorRevisaoPedido cidade-estado-usuario">
                          {dadosEndereco.cidade}-{dadosEndereco.estado}
                        </label>
                      </div>
                    </div>
                  </>
                )}

                <div className="totalReviseCompra">
                  <label className="tituloCardReviseCompraTotal">Total</label>
                  <label className="totalDestaque">
                    R${' '}
                    {(totalProdutos?.valorTotalProdutos + valorRecarga)
                      .toFixed(2)
                      .replace('.', ',')}
                  </label>
                </div>

                <div className="valoresReviseSuaCompra">
                  <label className="tituloReviseCompra">Frete</label>
                  <label className="valorRevisaoPedido">Grátis</label>
                </div>

                {subProductId === '001' && (
                  <>
                    <Divider type="full" onBg="light" />
                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">
                        Saldo final para uso
                      </label>
                      <label className="valorRevisaoPedido tipo-pagamento">
                        R$ {finalBalanceCalculation(valorRecarga)}
                      </label>
                    </div>
                  </>
                )}

                <Divider type="full" onBg="light" />
                <div className="containerBotaoVerMais" onClick={btnVerMais}>
                  <Link onBg="light">{botaoVerMais.label}</Link>
                  <Icon src={botaoVerMais.icon} size="sm" />
                </div>
              </div>
            </div>
          </Card>
          <div className="stack-button-container" />
          <Button
            className="stack-button-full"
            {...{
              onBg: 'light',
              color: 'primary',
              disabled: false,
              label: 'Continuar para pagamento',
              id: 'btn-continuar',
            }}
            onClick={chamaFuncRand}
          />
        </div>
      </div>
      {openModalInformativo &&
        modalInformativo(
          true,
          () => {
            setOpenModalInformativo(false);
          },
          'Ops!',
          textoTermos,
        )}
      <ScriptTag
        type="text/javascript"
        src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`}
      />
    </div>
  );
};

const mapStateToProps = ({ pedido }) => {
  return { pedido };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetTipoPagamento: () => dispatch(resetTipoPagamento()),
    salvarDesconto: (desconto) => dispatch(salvarDesconto(desconto)),
    salvarDescontoAsync: (desconto) => dispatch(salvarDescontoAsync(desconto)),
    activeLoader: () => dispatch({ type: 'loader_active' }),
    inactiveLoader: () => dispatch({ type: 'loader_inactive' }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(ReviseCompra));
